module.exports = __webpack_public_path__ + "img/unified-app-launch.89509196.svg";